import dayjs from 'dayjs';
import type {Repeat} from './repeatSchema';

type DoneLike = Date | null | undefined;

/**
 * Determine whether a repeating todo has expired, based on the last done time and repeat config.
 */
export function isTodoExpired(done: DoneLike, repeat: Repeat | null | undefined): boolean {
  if (!done || !repeat) {
    return false;
  }

  const doneTime = dayjs(done);
  const now = dayjs();

  if (repeat.unit === 'dayOfWeek' && repeat.daysOfWeek && repeat.daysOfWeek.length > 0) {
    const doneDayOfWeek = doneTime.day(); // 0=Sunday, 6=Saturday
    const daysSinceDone = now.diff(doneTime, 'day');

    if (daysSinceDone === 0) {
      return false;
    }

    const sortedDays = [...repeat.daysOfWeek].sort((a, b) => a - b);

    let minDaysUntilNext = Infinity;

    sortedDays.forEach((day) => {
      let daysToDay = day - doneDayOfWeek;
      if (daysToDay <= 0) {
        daysToDay += 7;
      }

      if (daysToDay < minDaysUntilNext) {
        minDaysUntilNext = daysToDay;
      }
    });

    return daysSinceDone >= minDaysUntilNext;
  }

  if (!repeat.number) {
    return false;
  }

  let expirationDate = doneTime;

  switch (repeat.unit) {
    case 'day':
      expirationDate = doneTime.add(repeat.number, 'day');
      break;
    case 'week':
      expirationDate = doneTime.add(repeat.number, 'week');
      break;
    case 'month':
      expirationDate = doneTime.add(repeat.number, 'month');
      break;
    case 'year':
      expirationDate = doneTime.add(repeat.number, 'year');
      break;
  }

  return now.isAfter(expirationDate);
}
